export const getItemCategoryList = state => {
    return state.list
}

export const getAllItemCategoryList = state => {
    return state.all_list
}

export const getItemCategoryDataProps = state => {
    return state.props
}

export const getItemCategoryList_Fabric = state => {
    return state.fabric_list
}


// WEBPACK FOOTER //
// ./src/store/modules/itemCategory/getters.js